module.exports = __webpack_public_path__ + "static/media/7.94c263df.png";